import React from 'react'

export const BoxHeader = props => {
  const { className } = props
  return (
    <div className={className ? 'box__title ' + className : 'box__title'}>
      {props.children}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.BoxHeader.js